/*
 * Rittec-Themes für Project HQ.
 *
 * Seit der Migration auf @rittec/themes@0.3.0 definiert dieses Modul KEINE eigenen
 * Theme-Objekte mehr. Die beiden Grundthemes (light/dark) und die fünf
 * experimentellen Themes (unicorn/football/spacetrek/terminal/matrix) sowie die
 * Design-Konstanten (CI, markerColors, petrolScale, grayScale, …) kommen aus dem
 * npm-Paket. Diese Datei bündelt nur noch:
 *   - `getThemeFor(name)` als schmale Auswahl-Hilfe für den ThemeProvider,
 *   - die Re-Exports der Paket-Konstanten, damit bestehende Importe weiterlaufen.
 */
import { type Theme } from '@mui/material/styles';
import { getRittecTheme, getExperimentellesTheme, isExperimentalTheme } from '@rittec/themes';
import type { ThemeName } from '../context/ThemeContext';

// Re-Exports aus @rittec/themes — NICHT mehr lokal definiert. Damit laufen
// bestehende Importe aus '../theme/rittecTheme' unverändert weiter.
export {
  CI,
  markerColors,
  petrolScale,
  grayScale,
  footballClubVariants,
  getFootballThemeForClub,
  contrastRatio,
  pickAccessibleText,
  relativeLuminance,
} from '@rittec/themes';

/**
 * Liefert das MUI-Theme zum gewählten Theme-Namen. Für 'light'/'dark' das eine
 * Grundtheme (`getRittecTheme()` — welches Schema sichtbar ist, entscheidet das
 * data-theme-Attribut, nicht diese Funktion), für die experimentellen Themes das
 * jeweilige eigenständige Theme-Objekt.
 */
export function getThemeFor(name: ThemeName): Theme {
  return isExperimentalTheme(name) ? getExperimentellesTheme(name) : getRittecTheme();
}

// Standardexport bleibt das Rittec-Basistheme (light+dark als colorSchemes). Das
// Paket exportiert sein Basistheme nicht als Default über den Paket-Einstieg
// (index.js nutzt `export *`, das den Default nicht weiterreicht) — daher hier
// über getRittecTheme() beziehen; das liefert dasselbe Basistheme-Objekt.
const rittecTheme: Theme = getRittecTheme();
export default rittecTheme;
